import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ResponseProps } from '../../../propsGlobal/responseProps';
import {
  categoriaFailure,
  categoriaRequest,
  categoriaSuccess,
} from './actions';
import { CommonTypes } from './types';

function* categorias({ payload }: ReturnType<typeof categoriaRequest>) {
  const { company } = payload;

  try {
    const response: ResponseProps = yield call(api.get, 'v1/categories', {
      headers: {
        'Content-Type': 'application/json',
        company,
        Authorization: '',
      },
    });

    yield put(categoriaSuccess(response.data));
  } catch (error) {
    yield put(categoriaFailure());
  }
}

export default all([takeLatest(CommonTypes.CATEGORIA_RESQUEST, categorias)]);
